import React from 'react';

import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import Slide from '@material-ui/core/Slide';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';

import StationsSearchForm from './StationsSearchForm';
import StationsTable from './StationsTable';
import SelectedStationsChips from './SelectedStationsChips';

import * as strings from '../../helpers/strings';

const styles = {
  chipCol: {
    padding: "10px 10px 0 0"
  }
}

const Transition = props => <Slide direction="up" {...props} />

const StationListDialog = ({ open, onClose, classes }) => (
  <Dialog
    fullScreen
    open={open}
    onClose={onClose}
    TransitionComponent={Transition}
    aria-labelledby="alert-dialog-title"
    aria-describedby="alert-dialog-description"
  >
    <DialogTitle id="alert-dialog-title">{strings.lblSelectStations}</DialogTitle>
    <DialogContent style={{ paddingTop: '10px'}}>
      <Grid container>
        <Grid item md={3} classes={{item: classes.chipCol}}>
          <Paper>
            <SelectedStationsChips/>
          </Paper>
        </Grid>
        <Grid item md={9}>
          <StationsSearchForm visibleAddBtn={false} />
          <StationsTable multiSelect={true} />
        </Grid>
      </Grid>
    </DialogContent>
    <DialogActions>
<Button onClick={onClose} color={strings.colorPrimary}>{`Save and Close`}</Button>
    </DialogActions>
  </Dialog>
)

export default withStyles(styles)(StationListDialog);